import React, { useContext, useEffect, useState } from "react";
import SocketContext, { generateRoomId } from "../../../providers/Socket";
import EventEmitter from "../../../utils/EventEmitter";
import { isSender } from "../../../utils/chat.utils";
import Chat from "../Chat/Chat";
import useConfig from "../../../hooks/use-config";
const initializeChat = (newChat) => {
    const roomId = generateRoomId(newChat.pid, newChat.oid, newChat.rooms[0].uid);
    return {
        id: roomId,
        details: Object.assign({}, newChat),
        hasMore: true
    };
};
const PopupChat = (props) => {
    const [chat, setChat] = useState(initializeChat(props.newChat));
    const { socket } = useContext(SocketContext);
    const { getPostViewUrl } = useConfig();
    useEffect(() => {
        EventEmitter.subscribe('history-rooms.set', function (data) {
            for (const chatItem of data) {
                if (chat.details.rooms[0].room !== chat.details.rooms[0].room)
                    continue;
                setChat((currentChat) => {
                    return Object.assign(Object.assign({}, currentChat), chatItem);
                });
                break;
            }
        });
        return () => {
            EventEmitter.unsubscribe("history-rooms.set");
        };
    }, [props.newChat]);
    useEffect(() => {
        if (!socket)
            return;
        EventEmitter.middleware("message", "pre", (data) => {
            if (chat.id != data.message.room) {
                EventEmitter.suspension("message.notify");
            }
        });
        EventEmitter.middleware("message", "post", (msg) => {
            EventEmitter.unsuspension("message.notify");
        });
        EventEmitter.subscribe("message.outside", (data) => {
            socket === null || socket === void 0 ? void 0 : socket.emit('history-flat-rooms', { type: 'all', limit: 1000 }, function (roomsData) {
                EventEmitter.emit('history-rooms', roomsData);
            });
            const isByMe = isSender(data);
            if (isByMe)
                return;
            if (chat.id !== data.message.room)
                return;
            socket === null || socket === void 0 ? void 0 : socket.emit('seen', data.pid, data.message.oid, data.uid, data.message.mid);
        });
        EventEmitter.subscribe("typing", roomId => {
            if (roomId !== chat.details.rooms[0].room) {
                return;
            }
            EventEmitter.emit("is-typing");
        });
        return () => {
            EventEmitter.unsubscribe("typing");
            EventEmitter.unsubscribe('message');
            EventEmitter.unmiddleware('message');
        };
    }, [socket, chat]);
    return (React.createElement(Chat, { chat: chat, onLoadChats: () => { }, clearCurrentChatHandler: props.onClear, url: getPostViewUrl(chat.details.pid) }));
};
export default PopupChat;
